
import { defineComponent, PropType, reactive } from 'vue'

// types
import { OneCT } from '@/core/types/one_c.types'

// components
import TheButton from '@/common/components/UI/TheButton/index.vue'

export default defineComponent({
    props: {
        item: {
            type: Object as PropType<OneCT>,
            required: true,
        },
    },
    components: {
        'the-button': TheButton,
    },
    setup(props) {
        const state = reactive({
            is_loading: false,
        })

        return { state }
    },
})
